import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const Card = ({ imageUrl, ...props }) => (
  <section className={styles.container(props.width || 470)}>
    <div className={styles.header}>
      {imageUrl && <img className={styles.headerImage} src={imageUrl} alt="" />}
      <h2 className={styles.title}>{props.title}</h2>
    </div>
    <div className={styles.content}>{props.children}</div>
  </section>
)

Card.propTypes = {
  imageUrl: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node,
}

export default Card
